import { createContext, useContext } from 'react';
import { Dimensions } from 'react-native';
const LocaleContext = createContext('en-en');
LocaleContext.displayName = 'LocaleContext';
export const DAY_COLUMNS = 7;
export const LocaleProvider = LocaleContext.Provider;
export function useLocale() {
    const locale = useContext(LocaleContext);
    const [language, country] = locale.split('-');
    return { language, country: country.toLowerCase() };
}
const SizeContext = createContext(Dimensions.get('window').width);
SizeContext.displayName = 'SizeContext';
export const SizeProvider = SizeContext.Provider;
export function useSize() {
    const width = useContext(SizeContext);
    const cellSize = Math.floor(width / DAY_COLUMNS);
    return {
        width,
        cellSize,
    };
}
const TodayContext = createContext(new Date());
TodayContext.displayName = 'TodayContext';
export const TodayProvider = TodayContext.Provider;
export function useToday() {
    return useContext(TodayContext);
}
const SetDateContext = createContext(() => { });
SetDateContext.displayName = 'SetDateContext';
export const SetDateProvider = SetDateContext.Provider;
export function useSetDate() {
    return useContext(SetDateContext);
}
const DateContext = createContext(undefined);
DateContext.displayName = 'DateContext';
export const DateProvider = DateContext.Provider;
export function useDate() {
    return useContext(DateContext);
}
const EndDateContext = createContext(undefined);
EndDateContext.displayName = 'EndDateContext';
export const EndDateProvider = EndDateContext.Provider;
export function useEndDate() {
    return useContext(EndDateContext);
}
const HolidayConfigContext = createContext({});
HolidayConfigContext.displayName = 'HolidayConfigContext';
export const HolidayConfigProvider = HolidayConfigContext.Provider;
export function useHolidayConfig() {
    return useContext(HolidayConfigContext);
}
export function useHolidayConfigWithYearMonth(year, realMonth) {
    var _a, _b;
    const holidayConfig = useHolidayConfig();
    return (_b = (_a = holidayConfig === null || holidayConfig === void 0 ? void 0 : holidayConfig[year]) === null || _a === void 0 ? void 0 : _a[realMonth]) !== null && _b !== void 0 ? _b : {};
}
const LegendConfigContext = createContext({});
LegendConfigContext.displayName = 'LegendConfigContext';
export const LegendConfigProvider = LegendConfigContext.Provider;
export function useLegendConfig() {
    return useContext(LegendConfigContext);
}
export function useLegendConfigWithYearMonth(year, realMonth) {
    var _a, _b;
    const legendConfig = useLegendConfig();
    return (_b = (_a = legendConfig === null || legendConfig === void 0 ? void 0 : legendConfig[year]) === null || _a === void 0 ? void 0 : _a[realMonth]) !== null && _b !== void 0 ? _b : [];
}
const DateConfigContext = createContext({});
DateConfigContext.displayName = 'DateConfigContext';
export const DateConfigProvider = DateConfigContext.Provider;
export function useDateConfig() {
    return useContext(DateConfigContext);
}
export function useDateConfigWithYearMonth(year, realMonth) {
    var _a, _b;
    const dateConfig = useDateConfig();
    return (_b = (_a = dateConfig === null || dateConfig === void 0 ? void 0 : dateConfig[year]) === null || _a === void 0 ? void 0 : _a[realMonth]) !== null && _b !== void 0 ? _b : {};
}
